import React from "react";
import styles from "./ContatoBox.module.css";
import instagram from "../../assets/contato/instagram.svg";
import linkedin from "../../assets/contato/linkedin.svg";
import whatsapp from "../../assets/contato/whatsapp.svg";
import facebook from "../../assets/contato/facebook.svg";

import Image from "next/future/image";
import dynamic from "next/dynamic";

// import MyMap from "../Map/MyMap";

const MapWithNoSSR = dynamic(() => import("../Map/MyMap"), {
  ssr: false,
});

const Contato = ({ noBg }) => {
  return (
    <section
      id="contato"
      className={noBg ? styles.bgContatoNone : styles.bgContato}
    >
      <div className=" container-main">
        <div className={styles.box}>
          <div className={styles.infoContato}>
            <div className={styles.boxSection}>
              <h3>Telefone:</h3>
              <p>+55 14 3283-8344 ramal: 220</p>
              <p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://api.whatsapp.com/send?phone=5514982180404"
                >
                  +55 14 98218-0404
                </a>
              </p>
            </div>

            <div className={styles.boxSection}>
              <h3>Email:</h3>
              <p>contato@salinasembalagem.com.br</p>
            </div>

            <div className={styles.redesSociais}>
              <h3>Redes Sociais: </h3>
              <div className={styles.icons}>
                <a
                  href="https://www.linkedin.com/in/salinas-embalagem-011768174/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image src={linkedin} alt="linkedin" height="40" width="40" />
                </a>
                <a
                  href="https://www.instagram.com/salinasembalagem/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    src={instagram}
                    alt="instagram"
                    height="40"
                    width="40"
                  />
                </a>
                <a
                  href="https://api.whatsapp.com/send?phone=5514982180404"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image src={whatsapp} alt="whatsapp" height="40" width="40" />
                </a>
                <a
                  href="https://pt-br.facebook.com/salinasembalagem/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image src={facebook} alt="facebook" height="40" width="40" />
                </a>
              </div>
            </div>
          </div>
          <div className={styles.infoEndereco}>
            <div className={styles.boxSection}>
              <h3>Endereço:</h3>

              <p>
                Rua Benedito Bergamasco, O-35 ,<br /> Parque Industrial II,
                Pederneiras – SP, Brasil,
                <br /> 17280-888
              </p>
            </div>

            <div>
              <MapWithNoSSR className={styles.mapa} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;
